<template>
  <v-layout class="settings-wrapper">
    <v-flex xs12 sm12 style="box-shadow: 0 3px 6px #0000000d">
      <div class="header">{{title}}</div>
      <div class="content">
        <slot name="content"></slot>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "SettingItemBox",
  props: {
    title: {
      type: String,
      default: ""
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../components/style/settings/settings-item-box.scss";
</style>
